@if (showSmartAppBanner) {
    <div class="banner-area" #bannerArea [style.height.px]="bannerCurrentHeight">
        <app-smart-app-banner></app-smart-app-banner>
    </div>
}

<div id="header-reg-main" class="header-min" [ngClass]="{ 'show-header': isAtTop }">
    <div id="header-wp" class="header-top-bar">
        <div id="mb-brand-reg">
            <div id="brand-center">
                <a id="mbbrand" class="header-link" href="/">
                    <picture class="brandhub-header__logo">
                        <img
                            src="assets/images/MB-star_white.svg"
                            alt="Mercedes-Benz brand logo"
                            class="brandhub-picture brandhub-picture--contain"
                            style="width: 48px; height: auto"
                            alt="logo"
                        />
                    </picture>
                </a>
            </div>
        </div>
        <div
            [ngClass]="showMenu ? 'menu-navigation-animation' : 'menu-navigation-animation-goup'"
            class="l1-menu"
        >
            <ng-container>
                @if (isLanguageSelector) {
                    <span class="menu-item top-menu-font">
                        <span
                            class="glow-button lang-padding"
                            [ngClass]="this.selectedLang === 'de-DE' ? 'language-active' : ''"
                            (click)="openLanguagePicker()"
                            >{{ languageToDisplay }}</span
                        >
                    </span>
                }
            </ng-container>
            <ng-container>
                <span class="menu-item top-menu-font privacy">
                    <span (click)="navigateToProviderPage()">{{
                        'CP_LM_FOOTER_PROVIDER' | translate
                    }}</span>
                    /
                    <span (click)="navigateToPrivacyPage()">{{
                        'CP_LM_FOOTER_PRIVACY' | translate
                    }}</span>
                </span>
            </ng-container>
            <ng-container>
                <div
                    class="login-button-class"
                    [ngClass]="
                        showMenu ? 'menu-navigation-animation' : 'menu-navigation-animation-goup'
                    "
                >
                    @if (showLoginLink) {
                        <span
                            class="menu-item top-menu-font glow-button"
                            (click)="triggerLogin()"
                            >{{ 'CP_LM_LANDINGPAGE_LOGIN' | translate }}</span
                        >
                    }
                    @if (!enableMyProfile || showLogout) {
                        <span
                            class="menu-item top-menu-font glow-button"
                            (click)="logout()"
                            >{{ 'CP_LM_LANDINGPAGE_LOGOUT' | translate }}</span
                        >
                    }
                </div>
            </ng-container>
            @if (showMenu || currentUser) {
                <div class="login-class">
                    @if (enableMyProfile) {
                        <div id="user-profile" class="desk-only">
                            <span (click)="profileClicked()" class="profile-base">
                                @if (!isMyProfileVisible) {
                                    <img
                                        class="prof-image"
                                        src="../../../assets/images/profile-fallback.png"
                                        alt=""
                                    />
                                }
                                @if (isMyProfileVisible && !!profileInfo) {
                                    <img
                                        class="prof-image"
                                        [style.background-image]="'url(' + (profileInfo.profileImageUrl ? profileInfo.profileImageUrl : profileImage) + ')'"
                                        alt=""
                                    />
                                }
                            </span>
                            <span class="profile-name" (click)="profileClicked()">
                                @if (!isMyProfileVisible) {
                                    <span class="first-name"
                                        >{{ 'CP_LM_MAINPAGE_MYPROFILE' | translate }}
                                    </span>
                                }
                                @if (isMyProfileVisible && !!profileInfo) {
                                    <span class="first-name">{{
                                        profileInfo.nickName || profileInfo.firstName
                                    }}</span>
                                }
                            </span>
                            @if (!showLogout) {
                                <div class="profile-menu">
                                    <ul>
                                        <li (click)="logout()">
                                            <span class="glow-button">{{
                                                'CP_LM_LANDINGPAGE_LOGOUT' | translate
                                            }}</span>
                                        </li>
                                    </ul>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
        <ng-container>
            <div class="menu-btn-top" [ngClass]="!showBottomMenu ? '' : 'menu-close'">
                <span (click)="showDropDownInMobile()" class="menu-item-menu-btn">{{
                    'CP_LM_LANDINGPAGE_MENU' | translate
                }}</span>
                <span (click)="showDropDownInMobile()" class="menu-item-menu-btn">{{
                    'CP_LM_LANDINGPAGE_CLOSE' | translate
                }}</span>
            </div>
        </ng-container>
    </div>
    <div class="header-top-bar-backdrop"></div>
    <ng-container>
        <div class="header-l2-menu">
            @if (showHeader && toggleHeader) {
                <div
                    [ngClass]="
                        showMenu ? 'header-navigation-animation' : 'header-navigation-animation-goup'
                    "
                    (mouseleave)="hideDropMenu()"
                    id="header-profile"
                    class="header-navigation"
                >
                    @if (isMyStoriesVisible) {
                        <span
                            id="mestories"
                            [ngClass]="this.selectedCategory === '/stories' ? 'active-menu' : ''"
                            (click)="handleMyStoriesNavigationClick()"
                            ><span class="menu-item">{{
                                'CP_LM_MAINPAGE_MYSTORIES' | translate
                            }}</span></span
                        >
                    }
                </div>
            }
        </div>
        <div class="header-l2-menu-backdrop"></div>
    </ng-container>

    <ng-container>
        <div
            [ngClass]="showBottomMenu ? 'mobile-list-comedown' : 'mobile-list-goup'"
            class="mobile-list"
        >
            <div class="mobile-nav-wrapper">
                <div class="mobile-main-nav">
                    @if (isMyStoriesVisible) {
                        <span
                            id="mobilemestories"
                            [ngClass]="
                                this.selectedCategory === '/home' ||
                                this.secondLastUrlElement === '/experience'
                                    ? 'active-menu'
                                    : ''
                            "
                            class="menu-item glow-button menu-options"
                            (click)="handleMyStoriesNavigationClick()"
                            >{{ 'CP_LM_MAINPAGE_MYSTORIES' | translate }}</span
                        >
                    }
                </div>
                <div class="mobile-bottom-nav">
                    <div class="mobile-login-block">
                        <ng-container>
                            @if (showLoginLink) {
                                <span
                                    class="menu-item-mobile-menu"
                                    (click)="triggerLogin()"
                                    >{{ 'CP_LM_LANDINGPAGE_LOGIN' | translate }}</span
                                >
                            }
                            @if (!enableMyProfile) {
                                <span
                                    class="menu-item-mobile-menu"
                                    (click)="logout()"
                                    >{{ 'CP_LM_LANDINGPAGE_LOGOUT' | translate }}</span
                                >
                            }
                        </ng-container>

                        <!-------Smaller Devices Code------->
                        @if (enableMyProfile) {
                            @if (!showLoginLink) {
                                <div id="user-profile-mobile">
                                    <div id="user-profile-info-mobile">
                                        <span (click)="profileClicked()" class="profile-base">
                                            @if (!isMyProfileVisible) {
                                                <img
                                                    class="prof-image"
                                                    src="../../../assets/images/profile-fallback.png"
                                                    alt=""
                                                />
                                            }
                                            @if (isMyProfileVisible && !!profileInfo) {
                                                <img
                                                    class="prof-image"
                                                    [style.background-image]="'url(' + profileImage + ')'"
                                                    alt=""
                                                />
                                            }
                                        </span>
                                        <span class="profile-name" (click)="profileClicked()">
                                            @if (!isMyProfileVisible) {
                                                <span class="first-name"
                                                    >{{ 'CP_LM_MAINPAGE_MYPROFILE' | translate }}
                                                </span>
                                            }
                                            @if (isMyProfileVisible && !!profileInfo) {
                                                <span class="first-name"
                                                    >{{
                                                        profileInfo.nickName || profileInfo.firstName
                                                    }}</span
                                                >
                                            }
                                        </span>
                                    </div>
                                    @if (!showLoginLink) {
                                        <div class="profile-menu">
                                            <ul>
                                                <li (click)="logout()">
                                                    <span class="glow-button">{{
                                                        'CP_LM_LANDINGPAGE_LOGOUT' | translate
                                                    }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    }
                                </div>
                            }
                        }
                    </div>
                    <span class="menu-item">
                        <span
                            class="glow-button lang-padding"
                            [ngClass]="this.selectedLang === 'de-DE' ? 'language-active' : ''"
                            (click)="openLanguagePicker()"
                            >{{ languageToDisplay }}</span
                        >
                    </span>
                    <span class="menu-item glow-button">
                        <span (click)="navigateToProviderPage()">{{
                            'CP_LM_FOOTER_PROVIDER' | translate
                        }}</span>
                        /
                        <span (click)="navigateToPrivacyPage()">{{
                            'CP_LM_FOOTER_PRIVACY' | translate
                        }}</span>
                    </span>
                </div>
            </div>
        </div>
    </ng-container>
</div>
<div id="bg-blur" [style.top.px]="bannerCurrentHeight"></div>
<div id="bg-mobile-blur"></div>

@if (isProfileClicked) {
    <div>
        <app-edit-profile (cancelClicked)="cancelClicked($event)"></app-edit-profile>
    </div>
}
